import { useMemo } from 'react';

import { useGetPatientData } from '../../../../../hooks/index.js';
import { parseHealthCategories } from './parseHealthCategories.ts';
import { useGetIntakeStatusBaseSteps } from '../useGetIntakeStatusBaseSteps.ts';
import { mergePatientDataWithIntakeStatus } from './mergePatientDataWithIntakeStatus.ts';

export const usePatientIntakeStatus = (patientId: string) => {
  const {
    data: patientData,
    isLoading: isLoadingPatientData,
    error: errorPatientData,
  } = useGetPatientData({ patientId });

  const {
    data: baseSteps,
    isLoading: isLoadingBaseSteps,
    error: errorBaseSteps,
  } = useGetIntakeStatusBaseSteps({
    patientId,
    enabled: !!patientData,
  });

  const healthCategories = useMemo(() => (patientData ? parseHealthCategories(patientData) : null), [patientData]);

  const patientIntakeStatus = useMemo(
    () => mergePatientDataWithIntakeStatus({ patientData, baseSteps }),
    [patientData, baseSteps],
  );

  return {
    healthCategories,
    data: patientIntakeStatus,
    isLoading: isLoadingBaseSteps || isLoadingPatientData,
    error: errorBaseSteps || errorPatientData,
  };
};
